import React from 'react';
import { useInView } from '../../hooks/useInView';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import FeaturesSection from './FeaturesSection';
import '../../App.css';

function Landing() {
  const { ref: aboutRef, isVisible: aboutVisible } = useInView();

  return (
    <div className="Landing">
      <HeroSection />

      {/* About Section */}
      <section id="about" className="section" ref={aboutRef}>
        <div className="container">
          <div className={`section-header ${aboutVisible ? 'visible' : ''}`}>
            <span className="section-label">Who We Are</span>
            <h2 className="section-title">Technology Partners for the Digital Age</h2>
            <p className="section-description">
              Aamb brings together cloud architects, software engineers,
              and data specialists to build the next generation of digital infrastructure.
            </p>
          </div>
        </div>
      </section>

      <ServicesSection />
      <FeaturesSection />
    </div>
  );
}

export default Landing;
